import { Injectable } from '@angular/core';
import { AddCrewGQL, AddCrewInput, Crew, CrewsByDateRangeGQL, DeleteCrewGQL } from '../../../../graphql/generated';
import { map } from 'rxjs/operators';
import { Subject, tap } from 'rxjs';
import { awaitLoading } from '../../shared/rxjs/await-loading';

interface GetCrewsInput {
    startDate: Date;
    endDate: Date;
}

@Injectable({
    providedIn: 'root',
})
export class CrewService {

    private readonly _created = new Subject<Crew>();
    public readonly created$ = this._created.asObservable();

    private readonly _deleted = new Subject<string>();
    public readonly deleted$ = this._deleted.asObservable();

    constructor(
        private readonly crewsByDateRangeQueryGQL: CrewsByDateRangeGQL,
        private readonly deleteCrewGQL: DeleteCrewGQL,
        private readonly addCrewGQL: AddCrewGQL,
    ) {
    }

    public addCrew(input: AddCrewInput) {
        return this.addCrewGQL.mutate({ input }).pipe(
            awaitLoading(),
            map(result => result.data.addCrew.addedCrew as Crew),
            tap(crew => this._created.next(crew)),
        );
    }

    public deleteCrew(crewId: string) {
        return this.deleteCrewGQL.mutate({ crewId }).pipe(
            awaitLoading(),
            map(result => result.data.deleteCrew.deletedCrewId),
            tap(crewId => this._deleted.next(crewId)),
        );
    }

    public getCrewsByDateRange(input: GetCrewsInput) {
        return this.crewsByDateRangeQueryGQL.watch(input, {
            fetchPolicy: 'cache-and-network',
        }).valueChanges.pipe(
            awaitLoading(),
            map(result => result.data.crewsByDateRange as Crew[]),
        );
    }
}
